import { ToastDescriptionWithTx } from 'components/Toast'
import contracts from 'config/constants/contracts'
import { useTranslation } from 'contexts/Localization'
import { useCallWithGasPrice } from 'hooks/useCallWithGasPrice'
import { usePiBridgeContract } from 'hooks/useContract'
import useToast from 'hooks/useToast'
import { useCallback, useState } from 'react'
import { getAddress } from 'utils/addressHelpers'

export const useMintPiNft = (account) => {
  const [requestedMint, setRequestedMint] = useState(false)
  const { callWithGasPrice } = useCallWithGasPrice()
  const piBridgeContract = usePiBridgeContract(getAddress(contracts.piNFTS))
  const [isAccoutLogin, setIsAccountLogin] = useState(true);
  
  const [pendingTx, setPendingTx] = useState(false)
  const { toastSuccess, toastError } = useToast()
  const { t } = useTranslation()

  const handleMint = useCallback(async () => {
    setPendingTx(true)
    if (account === undefined) { 
        setIsAccountLogin(false);
     }
    else if (account !== undefined) { 
    setIsAccountLogin(true);
    }
    try {
      setRequestedMint(true)
      const tx = await callWithGasPrice(piBridgeContract, 'safeMintWhiteList', [])
      const receip = await tx.wait()
      if (receip.status) {
        toastSuccess(
          t('Successful!'),
          // eslint-disable-next-line react/react-in-jsx-scope
          <ToastDescriptionWithTx txHash={receip.transactionHash}>
            {t(`You've minted an NFT!`)}
          </ToastDescriptionWithTx>
        )
      } else {
        toastError(t('Error'), t('Please try again. Confirm the transaction and make sure you are paying enough gas!'))
      }


    } catch (error) {
      console.log(error);
      toastError(t('Error'), t('Please try again. Confirm the transaction and make sure you are paying enough gas!'))
    } finally {
      setRequestedMint(false)
      setPendingTx(false)
    }
  }, [account, callWithGasPrice, piBridgeContract, t, toastError, toastSuccess])

  
  return { handleMint, requestedMint, pendingTx, isAccoutLogin}

}
